import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import jstat from 'jstat'
import auth from './auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth
  },
  state: {
    videoYear: process.env.VUE_APP_VIDEO_YEAR,
    leaderboardYear: process.env.VUE_APP_LEADERBOARD_YEAR,
    locationId: process.env.VUE_APP_LOCATION_ID,
    session: {
      id: null,
      count: 0,
      total: 0,
      lastCount: null
    },
    video: null,
    run: null
  },
  getters: {
    videoYear: state => state.videoYear,
    leaderboardYear: state => state.leaderboardYear,
    locationId: state => state.locationId,
    session: state => state.session,
    video: state => state.video,
    run: state => state.run
  },
  mutations: {
    setLocationId (state, locationId) {
      state.locationId = locationId
    },
    setSessionId (state, id) {
      state.session.id = id
    },
    setVideo (state, video) {
      state.video = video
    },
    setRun (state, run) {
      state.run = run
    },
    incrementSessionCount (state) {
      state.session.count = state.session.count + 1
    },
    incrementSessionTotal (state, count) {
      state.session.total = state.session.total + count
    },
    setSessionLastCount (state, count) {
      state.session.lastCount = count
    }
  },
  actions: {
    setSessionId ({ commit }, id) {
      commit('setSessionId', id)
    },
    updateSession ({ commit }, count) {
      commit('incrementSessionCount')
      commit('incrementSessionTotal', count)
      commit('setSessionLastCount', count)
    },
    fetchVideo ({ commit, state }) {
      // console.log('store:fetchVideo')
      return axios.get('/video/', {
        params: {
          // set min_count_mean > 0 to request video with fish in it (e.g. first of session)
          // min_count_mean: state.session.count === 0 ? 1 : 0,
          location_id: state.locationId
        }
      })
        .then((response) => {
          const videos = response.data.data

          if (!videos || videos.length === 0) {
            commit('setVideo', null)
            return Promise.reject({
              code: 'video/video-not-found',
              message: 'Did not receive a video'
            })
          }
          const video = videos[0]

          return commit('setVideo', video)
        })
    },
    fetchRun ({ commit, state }) {
      return axios.get('/run-estimate/', { params: { location_id: state.locationId } })
        .then((response) => {
          const data = response.data.data

          const total = data.reduce((p, v) => {
            p.y += v.y
            p.var_y += v.var_y
            p.df_num += v.df_num
            p.df_den += v.df_den
            return p
          }, { y: 0, var_y: 0, df_num: 0, df_den: 0 })

          const df = Math.round((total.df_num * total.df_num) / total.df_den)
          const tStar = jstat.studentt.inv(0.975, df)
          const range = tStar * Math.sqrt(total.var_y)
          return commit('setRun', {
            total: {
              y: Math.round(total.y),
              range: Math.round(range)
            }
          })
        })
    }
  }
})
